import { Roles } from '@/_shared/constants/roles';
import { ClusterType } from '@/swagger/constants/credits-enums';
import { User, UserStatus } from '../types';

export const MOCK_RESPONSE_POST_CREATE_DELEGATE_GUEST: User = {
  id: '1',
  email: 'prova@altermaind.com',
  firstName: 'Mario',
  lastName: 'Rossi',
  roles: [Roles.HR_Delegate],
  status: UserStatus.Enabled,
};

export const MOCK_RESPONSE_POST_CREATE_DELEGATE_EMPLOYER = {
  data: [
    {
      id: '1',
      email: 'prova@altermaind.com',
      firstName: 'Mario',
      lastName: 'Rossi',
      roles: [Roles.HR_Delegate],
      status: UserStatus.Enabled,
    },
  ],
  totalCreated: 1,
};

export const MOCK_RESPONSE_GET_DELEGATES = {
  data: [
    {
      id: '1',
      email: 'manager@altermaind.com',
      firstName: 'Mario',
      lastName: 'Manager',
      roles: [Roles.Admin],
      status: UserStatus.Enabled,
    },
    {
      id: '2',
      email: 'prova@altermaind.com',
      firstName: 'Mario',
      lastName: 'Rossi',
      roles: [Roles.HR_Delegate],
      status: UserStatus.Enabled,
    },
  ],
  totalItems: 2,
};

export const MOCK_RESPONSE_DELETE_DELEGATE = {};

export const MOCK_RESPONSE_POST_DELEGATE_ACTIVATION_EMAIL = {};

export const MOCK_RESPONSE_GET_ORGANIZATION_CREDITS_QUARTER = [
  {
    quarter: '1',
    year: 2024,
  },
];

export const MOCK_RESPONSE_GET_ORGANIZATION_CREDITS = {
  quarter: 1,
  year: 2024,
  stats: {
    employees: {
      total: 12,
    },
    assigned: 1000,
    used: 600,
    remaining: 400,
    utilizationPercentage: 60,
    usersCount: 12,
    clusterUsers: [
      {
        clusterName: ClusterType.INATTIVI,
        usersNumber: 5,
        avgUsedCredits: 50,
      },
    ],
    avgUsedPerPerson: 50,
    monthlyUsage: {
      '2025-01': 100.5,
      '2025-02': 120,
      '2025-03': 95.7,
    },
  },
  departments: [],
};
